var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.href ? "a" : "button",
    _vm._g(
      _vm._b(
        {
          tag: "component",
          staticClass: "btn",
          class: _vm.buttonClass,
          attrs: { href: _vm.href },
        },
        "component",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }